import React from 'react';
import { translate } from 'App/Internationalization';
import images from 'config/local/images';
import LinkButton from 'shared/LinkButton';
import paths from 'config/local/paths';

export default class GenericAvmLeadOverlay extends React.Component {
	/** @returns {string} */
	static #getTenant() {
		const host = window.location.hostname.toLowerCase();
		if (host.includes('simplyhome')) {
			return translate('global.tenants.simplyhome');
		}
		return translate('global.tenants.homekeepr');
	}

	render() {
		return (
			<section className="my-5 message message-themed-light">
				<header className="header">
					<h2 className="title large">
						{translate(
							'agent.pages.contacts.view.upgrade_table.AvmLead_popup.title'
						)}
					</h2>
				</header>
				<main className="container-sm">
					<ul className="list-group">
						<li
							dangerouslySetInnerHTML={{
								__html: translate(
									'agent.pages.contacts.view.upgrade_table.AvmLead_popup.message_1'
								),
							}}
						/>
						<li
							dangerouslySetInnerHTML={{
								__html: translate(
									'agent.pages.contacts.view.upgrade_table.AvmLead_popup.message_2',
									GenericAvmLeadOverlay.#getTenant()
								),
							}}
						/>
					</ul>
				</main>
				<footer className="footer">
					<LinkButton
						className="button button-icon"
						icon={images.icons.subscription}
						iconClass="icon"
						to={paths.app.agent.subscription.root}
					>
						{translate(
							'agent.pages.contacts.view.upgrade_table.upgrade'
						)}
					</LinkButton>
				</footer>
			</section>
		);
	}
}
